// src/dashboard/pages/teacher/ToDoList/components/TaskKanbanBoard.jsx

import React from "react";

import {
  STATUS_META,
  STATUS_ORDER,
} from "../utils/toDoListDashboardUtils";

import TaskCard from "./TaskCard";

export default function TaskKanbanBoard({
  groupedTasks,
  dragOverStatus,
  deletingId,
  onEdit,
  onDelete,
  onChangeStatus,
  onDragStart,
  onDragOver,
  onDragEnter,
  onDragLeave,
  onDrop,
}) {
  return (
    <div className="mt-5 overflow-x-auto pb-2">
      <div className="grid min-w-[1120px] grid-cols-4 gap-4">
        {STATUS_ORDER.map((status) => {
          const meta = STATUS_META[status];
          const items = groupedTasks.get(status) || [];
          const isOver = dragOverStatus === status;

          return (
            <section
              key={status}
              className={`min-h-[460px] rounded-[24px] border ${meta.ring} ${meta.col} p-3 transition ${
                isOver ? "ring-2 ring-indigo-500" : ""
              }`}
              onDragOver={(event) => onDragOver(event, status)}
              onDragEnter={(event) => onDragEnter(event, status)}
              onDragLeave={(event) => onDragLeave(event, status)}
              onDrop={(event) => onDrop(event, status)}
              role="list"
              aria-label={`Colonne ${status}`}
            >
              <header className="mb-3 flex items-center justify-between gap-3 px-1">
                <div>
                  <h3 className={`text-sm font-bold ${meta.head}`}>
                    {meta.label}
                  </h3>

                  <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
                    {items.length} tâche(s)
                  </p>
                </div>

                <span
                  className={`inline-flex h-8 min-w-8 items-center justify-center rounded-2xl px-2 text-xs font-bold ${meta.badge}`}
                >
                  {items.length}
                </span>
              </header>

              <div className="space-y-3">
                {items.length === 0 ? (
                  <div className="rounded-2xl border border-dashed border-slate-300 bg-white/60 p-4 text-center text-xs font-medium text-slate-500 dark:border-slate-700 dark:bg-slate-900/30 dark:text-slate-400">
                    Déposez une tâche ici
                  </div>
                ) : (
                  items.map((task) => (
                    <TaskCard
                      key={task.id}
                      task={task}
                      deletingId={deletingId}
                      onEdit={onEdit}
                      onDelete={onDelete}
                      onChangeStatus={onChangeStatus}
                      onDragStart={onDragStart}
                    />
                  ))
                )}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}